import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Logo = ({ to, altText }) => {
  return (
    <SiteBrand to={to} aria-label={altText}>
      <Wordmark>POLYBET</Wordmark>
    </SiteBrand>
  );
};

export default Logo;

const SiteBrand = styled(Link)`
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  white-space: nowrap;

  &:hover,
  &:focus-visible {
    text-decoration: none;
    opacity: 0.92;
  }
`;

const Wordmark = styled.span`
  display: inline-block;
  font-family: 'Orbitron', 'Rajdhani', 'Segoe UI', sans-serif;
  font-size: 24px;
  font-weight: 900;
  letter-spacing: 0.15em;
  line-height: 32px;
  text-transform: uppercase;
  background: linear-gradient(135deg, hsl(263 70% 60%), hsl(190 95% 45%));
  color: transparent;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;
